module.exports = __webpack_public_path__ + "img/SY.ec939387.svg";